"use strict";
$(function ($) {
  /* ドロワーメニュー */
  $('#js-hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('#js-drawer-menu').toggleClass('is-active');
    $('.header__inner').toggleClass('is-active'); // .header__innerにもis-activeを付け外し

    // Text change between MENU and CLOSE
    // if ($(this).hasClass('is-active')) {
    //   $(this).find('p').text('close');
    // } else {
    //   $(this).find('p').text('Menu');
    // }
  });

  // ハンバーガーメニュー内をクリックしたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click');
  });
});



// const btn = document.querySelector('.contactForm__btn-previous');
// if (btn) {
//   btn.addEventListener('click', () => {
//     console.log('Previous button clicked');
//   });
//   console.log(getComputedStyle(btn).display);
// } else {
//   console.error('Element .contactForm__btn-previous not found');
// }






/* ----- FAQのアコーディオン ----- */
$(".topQa__item").on("click", function() {
  $(this).find(".topQa__answer").slideToggle(); // 回答部分をスライド
  $(this).find(".topQa__question").toggleClass("is-active"); // 質問部分にクラスを追加
});




/* ----- fvースライダー ----- */
if (document.body.classList.contains('top-page')) {
  const splide = new Splide(".splide__fv", {
    // Splideの設定
    type: "fade", // フェード
    autoplay: true, // 自動再生
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false, // 矢印ボタンを非表示
    interval: 3000,
    speed: 2000,
    perPage: 1,
    classes: {
      pagination: "splide__pagination your-class-pagination",
      page: "splide__pagination__page your-class-page",
    },
  }).mount();
}

/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;
// スマホサイズの時の追加オフセット（必要に応じて調整）
const mobileOffset = 0; // 50px 追加オフセット
// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

      // スマホサイズの場合の追加オフセット
      if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
        position += mobileOffset;
      }

      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};
// // 別ページ遷移後にスムーススクロール
// const urlHash = window.location.hash;
// if (urlHash) {
//   const target = document.getElementById(urlHash.slice(1));
//   if (target) {
//     // ページトップから開始（ブラウザ差異を考慮して併用）
//     history.replaceState(null, '', window.location.pathname);
//     window.scrollTo(0, 0);

//     window.addEventListener("load", () => {
//       let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

//       // スマホサイズの場合の追加オフセット
//       if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
//         position += mobileOffset;
//       }

//       window.scrollTo(0, position);

//       // ハッシュを再設定
//       history.replaceState(null, '', window.location.pathname + urlHash);
//     });
//   }
// }



// /* ----- フェードイン ----- */
// window.addEventListener('scroll', function(){
//   // スクロール量を取得
//   const scroll = window.scrollY;
//   // 画面の高さを取得
//   const windowHeight = window.innerHeight;
//   // すべての.boxを取得
//   const boxes = document.querySelectorAll('.fade');

//   boxes.forEach(function(box) {
//     // boxまでの高さを取得
//     const distanceToBox = box.offsetTop;
//     // 下記条件が成り立つときだけboxにis-activeクラスを付与する
//     if(scroll + windowHeight > distanceToBox) {
//       box.classList.add('is-active');
//     }
//   });
// });
